/**
 * Joins a list of class names into a single string, filtering out falsy values.
 * Accepts nested arrays and flattens them recursively.
 *
 * @param {unknown[]} classes - An array (possibly nested) of class names,
 *                              which can include strings, numbers, booleans, null, undefined, etc.
 * @returns {string} A space-separated string of truthy class names.
 *
 * @example
 * classNames(['btn', true && 'active', null, ['rounded', [false, 'lg']]])
 * // Returns: "btn active rounded lg"
 */
export const classNames = (classes: unknown[]): string =>
  classes.flat(Number.POSITIVE_INFINITY).filter(Boolean).join(" ");
